import { CircularProgress } from "@mui/material";
import { Suspense } from "react";

export default function SuspenseComponent({ children }) {
  return <Suspense fallback={<CircularProgress />}>{children}</Suspense>;
}
